import { Injectable, signal } from '@angular/core';
import { fromEvent, merge, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConexionService {
  
  // Opción 1: Usando un Observable tradicional de RxJS
  public conectado$: Observable<boolean>;

  // Opción 2: Usando Angular Signals (si usas Angular 16+)
  public estaConectado = signal<boolean>(navigator.onLine);

  constructor() {
    // Combinamos los eventos nativos del navegador 'online' y 'offline'
    this.conectado$ = merge(
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false))
    );

    // Mantener actualizado el Signal
    fromEvent(window, 'online').subscribe(() => this.estaConectado.set(true));
    fromEvent(window, 'offline').subscribe(() => this.estaConectado.set(false));
  }

  // Método rápido para obtener el estado síncrono actual
  obtenerEstadoActual(): boolean {
    return navigator.onLine;
  }
}